import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Radio,
  SvgIconProps,
  Typography,
} from '@mui/material';
import { MouseEventHandler, ReactElement, cloneElement } from 'react';
import { t } from 'i18next';
import { theme } from '@store';

export interface IMfaMethodCardProps {
  title: string;
  description: string;
  isChecked: boolean;
  isSetUp: boolean;
  onCheck: () => void;
  icon: ReactElement<SvgIconProps>;
  onClick: MouseEventHandler<HTMLButtonElement>;
}

export const MfaMethodCard = ({
  title,
  description,
  isChecked,
  isSetUp,
  onCheck,
  icon,
  onClick,
}: IMfaMethodCardProps) => {
  return (
    <Card
      sx={{
        borderRadius: 0,
        boxShadow: 0,
        width: '100%',
        border: `1px solid ${theme.palette.action.disabled}`,
      }}
    >
      <CardActionArea
        sx={{
          py: '1rem',
          px: '0.5rem',
          bgcolor: isChecked
            ? theme.palette.primary.main + '1a'
            : 'transparent',
          height: '100%',
        }}
        onClick={onCheck}
      >
        <CardContent
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            p: 0,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
            }}
          >
            <Radio checked={isChecked} />
            <Box
              sx={{
                display: 'flex',
                gap: '0.5rem',
                alignItems: 'center',
              }}
            >
              {cloneElement(icon, {
                sx: {
                  color: isChecked
                    ? theme.palette.primary.main
                    : theme.palette.action.disabled,
                },
              })}
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Typography variant='subtitle2'>{title}</Typography>
                <Typography
                  variant='body2'
                  sx={{ color: theme => theme.palette.semiBlack.main }}
                >
                  {description}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Button
            variant='outlined'
            color='primary'
            sx={{
              fontSize: '0,875rem',
              fontWeight: 'medium',
              color: 'primary.main',
              px: '0.5rem',
            }}
            component='span'
            onClick={onClick}
            loadingPosition='center'
          >
            {isSetUp
              ? t('profile.privacy.mfaSection.deleteButtonLabel')
              : t('profile.privacy.mfaSection.setupButtonLabel')}
          </Button>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};
